<div class="work-overview-container">
  <div class="panel">
    <div class="panel-header">
      <h2>施工概覽管理</h2>
      <div class="header-actions">
        <div class="search-box">
          <input type="text" placeholder="搜尋申請單..." [(ngModel)]="applicationSearch" (input)="filterApplications()">
          <i class="fas fa-search"></i>
        </div>
      </div>
    </div>

    <div class="panel-content">
      <!-- 主表：施工申請單列表 -->
      <div class="master-section">
        <div class="section-header">
          <h3>施工申請單列表</h3>
        </div>

        <div class="table-responsive">
          <table class="data-table">
            <thead>
              <tr>
                <th>申請單號</th>
                <th>承包單位</th>
                <th>施工地點</th>
                <th>施工期間</th>
                <th>狀態</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let application of filteredWorkApplications"
                [class.selected]="application === selectedWorkApplication" (click)="selectWorkApplication(application)">
                <td>{{application.id}}</td>
                <td>{{application.contractingUnit}}</td>
                <td>{{application.workLocation}}</td>
                <td>{{application.workPeriodStart}} ~ {{application.workPeriodEnd}}</td>
                <td>
                  <span class="status-badge" [ngClass]="'status-' + application.status">
                    {{getStatusText(application.status)}}
                  </span>
                </td>
                <td class="action-cell">
                  <button class="btn btn-sm btn-primary"
                    (click)="selectWorkApplication(application); $event.stopPropagation();">
                    <i class="fas fa-list-ul"></i> 查看日程
                  </button>
                </td>
              </tr>
              <tr *ngIf="filteredWorkApplications.length === 0">
                <td colspan="6" class="no-data">沒有符合條件的施工申請單</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 從表：施工日程列表 -->
      <div class="detail-section" *ngIf="selectedWorkApplication">
        <div class="section-header">
          <div class="section-title">
            <h3>{{ selectedWorkApplication.contractingUnit }} - 施工日程列表</h3>
            <span class="application-info">申請單號: {{selectedWorkApplication.id}} | 施工期間:
              {{selectedWorkApplication.workPeriodStart}} ~ {{selectedWorkApplication.workPeriodEnd}}</span>
          </div>
          <div class="section-actions">
            <button class="btn btn-primary" (click)="openWorkDayModal()">
              <i class="fas fa-plus"></i> 新增施工日
            </button>
          </div>
        </div>

        <div class="table-responsive">
          <table class="data-table">
            <thead>
              <tr>
                <th>日期</th>
                <th>是否施工</th>
                <th>特殊作業</th>
                <th>工作描述</th>
                <th>入廠人數</th>
                <th>資格確認</th> <!-- 新增的資格確認欄位 -->
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let workDay of workDaysList">
                <td>{{formatDate(workDay.date)}}</td>
                <td>
                  <span class="status-dot" [class.active]="workDay.isWorkingDay"></span>
                  {{workDay.isWorkingDay ? '是' : '否'}}
                </td>
                <td>
                  <div class="special-work-tags" *ngIf="workDay.isWorkingDay">
                    <span class="work-tag" *ngIf="workDay.workType1">動火</span>
                    <span class="work-tag" *ngIf="workDay.workType2">吊掛</span>
                    <span class="work-tag" *ngIf="workDay.workType3">局限</span>
                    <span class="work-tag" *ngIf="workDay.workType4">有機</span>
                    <span class="work-tag" *ngIf="workDay.workType5">高架</span>
                    <span class="work-tag" *ngIf="workDay.workType6">消防</span>
                    <span *ngIf="!hasSpecialWork(workDay)">無</span>
                  </div>
                  <span *ngIf="!workDay.isWorkingDay">-</span>
                </td>
                <td>
                  <div class="work-description" [title]="workDay.workDescription">
                    {{workDay.workDescription || '-'}}
                  </div>
                </td>
                <td>{{workDay.isWorkingDay ? (workDay.personnel.length || 0) : '-'}}</td>
                <!-- 新增的資格確認欄位 -->
                <td>
                  <div *ngIf="workDay.isWorkingDay && workDay.personnel.length > 0">
                    <div class="qualification-status" [ngClass]="getQualificationStatusClass(workDay)">
                      <i [class]="getQualificationStatusIcon(workDay)"></i>
                      {{getQualificationStatusText(workDay)}}
                      <div class="qualification-tooltip" *ngIf="hasQualificationIssues(workDay)">
                        <div *ngFor="let issue of getQualificationIssues(workDay)" class="qualification-issue">
                          <i class="fas fa-exclamation-triangle"></i> {{issue}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <span *ngIf="!workDay.isWorkingDay || workDay.personnel.length === 0">-</span>
                </td>
                <td class="action-cell">
                  <button class="btn btn-sm btn-info" (click)="openWorkDayModal(workDay)">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-danger" (click)="deleteWorkDay(workDay)">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="workDaysList.length === 0">
                <td colspan="7" class="no-data">尚未安排任何施工日程</td> <!-- 更新colspan為7 -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- 新增/編輯施工日程對話框 -->
  <div class="modal" *ngIf="showWorkDayModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>{{editingWorkDay ? '編輯' : '新增'}}施工日程</h5>
          <button type="button" class="close" (click)="closeWorkDayModal()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="workDayForm">
            <div class="form-group">
              <label>施工日期：</label>
              <select class="form-control" formControlName="workDate" required>
                <option value="">請選擇日期</option>
                <option *ngFor="let date of availableDates" [value]="date">{{formatDate(date)}}</option>
              </select>
              <small class="text-danger"
                *ngIf="workDayForm.get('workDate')?.invalid && workDayForm.get('workDate')?.touched">
                請選擇日期
              </small>
            </div>

            <div class="form-group">
              <label>是否進場施工：</label>
              <div class="checkbox-item">
                <input type="checkbox" id="isWorkingDay" formControlName="isWorkingDay">
                <label for="isWorkingDay">當日進行施工</label>
              </div>
            </div>

            <ng-container *ngIf="workDayForm.get('isWorkingDay')?.value">
              <div class="special-work-types">
                <label>特殊作業類型：</label>
                <div class="checkbox-container">
                  <div class="checkbox-row">
                    <div class="checkbox-item">
                      <input type="checkbox" id="workType1" formControlName="workType1">
                      <label for="workType1">a. 動火作業許可證</label>
                    </div>
                    <div class="checkbox-item">
                      <input type="checkbox" id="workType2" formControlName="workType2">
                      <label for="workType2">b. 吊掛作業許可證(21天前)</label>
                    </div>
                    <div class="checkbox-item">
                      <input type="checkbox" id="workType3" formControlName="workType3">
                      <label for="workType3">c. 局限空間作業許可證</label>
                    </div>
                    <div class="checkbox-item">
                      <input type="checkbox" id="workType4" formControlName="workType4">
                      <label for="workType4">d. 有機溶劑作業許可證</label>
                    </div>
                    <div class="checkbox-item">
                      <input type="checkbox" id="workType5" formControlName="workType5">
                      <label for="workType5">e. 高架作業許可證</label>
                    </div>
                    <div class="checkbox-item">
                      <input type="checkbox" id="workType6" formControlName="workType6">
                      <label for="workType6">f. 消防系統及火警系統隔離許可</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>工作描述：</label>
                <textarea class="form-control" formControlName="workDescription" rows="3"></textarea>
              </div>

              <!-- 當日入廠人員 -->
              <div class="personnel-section">
                <div class="section-header">
                  <h5>當日入廠人員</h5>
                  <button type="button" class="btn btn-sm btn-primary" (click)="addPersonnel()">
                    <i class="fas fa-plus"></i> 新增人員
                  </button>
                </div>

                <div class="table-responsive">
                  <table class="data-table" *ngIf="personnel.length > 0">
                    <thead>
                      <tr>
                        <th>姓名</th>
                        <th>身分證號</th>
                        <th>聯絡電話</th>
                        <th>工種</th>
                        <th>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let person of personnel; let i = index">
                        <td>{{person.name}}</td>
                        <td>{{person.idNumber}}</td>
                        <td>{{person.phone}}</td>
                        <td>{{person.jobType}}</td>
                        <td class="action-cell">
                          <button type="button" class="btn btn-sm btn-danger" (click)="removePersonnel(i)">
                            <i class="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngIf="personnel.length === 0" class="no-data">
                    尚未新增入廠人員
                  </div>
                </div>
              </div>
            </ng-container>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeWorkDayModal()">
            取消
          </button>
          <button type="button" class="btn btn-primary" [disabled]="workDayForm.invalid" (click)="saveWorkDay()">
            儲存
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 人員選擇對話框 -->
  <div class="modal" *ngIf="showPersonnelModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>選擇入廠人員</h5>
          <button type="button" class="close" (click)="closePersonnelModal()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <input type="text" class="form-control" placeholder="搜尋人員..." [(ngModel)]="personnelSearch"
              (input)="filterPersonnel()">
          </div>

          <div class="contractor-personnel">
            <div class="section-header">
              <h6>可用人員列表</h6>
            </div>

            <div class="table-responsive">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>選擇</th>
                    <th>姓名</th>
                    <th>身分證號</th>
                    <th>聯絡電話</th>
                    <th>工種</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let person of filteredContractorPersonnel">
                    <td>
                      <input type="checkbox" [checked]="isPersonnelSelected(person)"
                        (change)="togglePersonnelSelection(person)">
                    </td>
                    <td>{{person.name}}</td>
                    <td>{{person.idNumber}}</td>
                    <td>{{person.phone}}</td>
                    <td>{{person.jobType}}</td>
                  </tr>
                  <tr *ngIf="filteredContractorPersonnel.length === 0">
                    <td colspan="5" class="no-data">沒有符合條件的人員</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closePersonnelModal()">
            取消
          </button>
          <button type="button" class="btn btn-primary" (click)="confirmPersonnelSelection()">
            確認選擇 ({{selectedPersonnel.length}}人)
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
